<template>

    <div class="input-wrapper" :class="{ active : isActive }">
        <span class="placeholder">{{ placeholder }}</span>
        <div class="prc-tag txt-grt ft-xbld" v-if="hasPriceTag">
            <span class="b">€</span>
            <span class="s">/{{ priceTagPeriod }}</span>
        </div>
        <input type="text" autocomplete="off" ref="input" 
            :maxlength="maxChars"
            :value="value"
            @focus="focus" 
            @blur="blur"
            @input="handleInput"
        />
    </div>

</template>

<script>

    export default {

        name: 'InputWrapper',

        props: {
            value: {
                type: String,
            },
            maxChars: {
                type: Number,
                default: null
            },
            placeholder: String,
            hasPriceTag: {
                type: Boolean,
                default: false
            },
            priceTagPeriod: String,
        },

        data() {
            return {
                isFocused: false,
                vValue: null
            }
        },

        computed: {

            isActive() {
                return this.isFocused || this.vValue
            }
        },

        mounted() {
            this.vValue = this.value
        },

        methods: {

            focus() {
                this.isFocused = true
            },

            blur() {
                if (!this.vValue) this.isFocused = false
                // if (this.vValue && !this.isMail){
                //     this.isValid = true
                //     this.$emit('inputreturn', this.isValid)
                //     if (this.hasEmit) this.emitTrigger()
                // }
            },

            handleInput(e) {
                this.vValue = e.target.value
                this.$emit("input", this.vValue)
            }
        }
    }

</script>